export default __webpack_public_path__ + "static/media/single_web-lg@2x.6162683d.jpg";